import { Link, useLocation } from "@tanstack/react-router";
import { FileText, Users } from "lucide-react";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/frontend/components/ui/sidebar";
import { usePatientListCountsQuery } from "@/frontend/queries/dashboard/patients";
import { useWorkspacePersona } from "./individual/useWorkspacePersona";

/**
 * Sidebar nav outside a patient, a link to the patient table with its count. An
 * individual workspace has no table, so the link is labelled "My records" and
 * carries no count.
 */
export function WorkspaceNav() {
  const location = useLocation();
  const { isIndividual } = useWorkspacePersona();
  const { data: counts } = usePatientListCountsQuery();
  const isPatients = location.pathname.startsWith("/dashboard/patients");

  const label = isIndividual ? "My records" : "Patients";
  const Icon = isIndividual ? FileText : Users;

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={isPatients} tooltip={label}>
              <Link to="/dashboard/patients" search={{}}>
                <Icon />
                <span>{label}</span>
              </Link>
            </SidebarMenuButton>
            {!isIndividual && !!counts?.total && (
              <SidebarMenuBadge className="text-[10px] tabular-nums text-muted-foreground">
                {counts.total.toLocaleString()}
              </SidebarMenuBadge>
            )}
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
